
const ExcelJS = require('exceljs')
import {getBase64ImageFromURL} from './pdfMakeTbl'
import {csvLines} from './exportList'
import _ from 'lodash'
import flow from "lodash/fp/flow";


export default async function createXLSX(products: any) {
    
    const workbook = new ExcelJS.Workbook();
        
    var fileDownload = require('js-file-download');
    await generateXLSX(workbook,products)
    
    let bufferconstbuffer= await workbook.xlsx.writeBuffer()
    fileDownload(  bufferconstbuffer , 'EdTech Index Shortlist and Decision Rubric.xlsx');
    
}

export class xlsLines extends csvLines{
    constructor(products) {
      // this.products = products;
      super(products)
    }

    dataValidationOptions = (optionLineNumber:number) => {
      const options= {
      1:   ['"Cannot Solve Pain Point nor satisfy non-negotiables,Meets most requirements and might be able to solve pain point,Can effectively solve pain point and meets most or all non-negotiable"']
      ,3:  ['"Not Aligned,Aligned,Aligned Completely"']
      ,4: ['"Not Aligned,Aligned,Aligned Completely,Not Applicable"']
      ,5: ['"Not Aligned,Aligned,Aligned Completely,Not Applicable"']
      ,6: ['"Not Engaging,Engaging,Highly Engaging"']
      ,7:['"Not easy to adopt or use,Adoptable and Usable,Easy to use and highly adoptable,Unable to tell from information provided"']
      ,8: ['"I see it fitting well,I see it somewhat aligned - but will need to be augmented in order to fit our curriculum sequence and pace,I see it difficult to integrate into the curriculum as we currently have it, Not applicable"']

      ,10: ['"This product appears be designed to reach all learners,This product doesn\'t appear to conductive to meeting all learners\' needs,This solution considers some criteria toward meeting all learners but is lacking in others,Not Applicable"']
      ,11: ['"Does not meet requirements,Fits 50%-75% of requirements,Meets most(75%-100%) of requirements,not applicable,need more information to determine"']

      ,13: ['"Does not meet requirements,Fits 50%-75% of requirements,Meets most(75%-100%) of requirements,not applicable,need more information to determine"']
      ,14:  ['"Unclear,No,Yes"']
      ,15:  ['"Unclear,No,Yes"']
    }

    return options[optionLineNumber]
  
  }
  

    productName = () => [['', ...this.products.map(_ => (_.name))]];
    ultid = () => [['ULTID', ...this.products.map(_ => (_.ultid))]];
    productLink   = () => [['Product URL',  ...this.products.map (_ => ( _.mainEntityOfPage ))]]
  
      productDesc = () => [[ 'Product Description' , ...this.products.map(_ => (_.publicDescription ))]];

 // TODO: see exportList.tsx from line 97  
      indexSiteLink = () => [[ 'Index URL' , ...this.products.map(_ => (window.location.href.replace(/\/[^\/]*\/$/, '/product/?recordId=' + _.productKey)  ))]];

      learningAudience	= () => [['Audiences', ...this.products.map(_ => ( (this.undefToValueHashArr(_.learningAudience).map(_ => (_.value)).join(', '))  ))]]
      educationalLevel	= () => [['Education Level',   ...this.products.map(_ => ( (this.undefToValueHashArr(_.educationalLevel).map(_ => (_.value)).join(', '))  ))]]
      intendedProductUser	= () => [['Primary Users',   ...this.products.map(_ => ( (this.undefToValueHashArr(_.intendedProductUser).map(_ => (_.value)).join(', '))  ))]]
      productCategories	= () => [['Product Categories',   ...this.products.map(_ => ( (this.undefToValueHashArr(_.learningTechnologyCategory).map(_ => (_.value)).join(', '))  ))]]
      academicDiscipline	= () => [['Discipline',   ...this.products.map(_ => ( (this.undefToValueHashArr(_.academicDiscipline).map(_ => (_.value)).join(', '))  ))]]
      academicSubjectArea	= () => [['Subjects Area',   ...this.products.map(_ => ( (this.undefToValueHashArr(_.academicSubjectArea).map(_ => (_.value)).join(', '))  ))]]
      academicContentStandards	= () => [['Content Standards',   ...this.products.map(_ => ( (this.undefToValueHashArr(_.academicContentStandards).map(_ => (_.value)).join(', '))  ))]]
      contentAttributes	= () => [['Content Attributes',   ...this.products.map(_ => ( (this.undefToValueHashArr(_.contentAttributes).map(_ => (_.value)).join(', '))  ))]]

      // TODO: checking label with user
      learningInteraction = () => [['Learning Interaction',   ...this.products.map(_ => ( (this.undefToValueHashArr(_.learningInteraction).map(_ => (_.value)).join(', '))  ))]]
      instructionalFeedback =() => [['Instructional Feedback',   ...this.products.map(_ => ( (this.undefToValueHashArr(_.instructionalFeedback).map(_ => (_.value)).join(', '))  ))]]
      learnerProgressTracking  = () => [[   'Learner Progress Features'  ,   ...this.products.map(_ => ( (this.undefToValueHashArr(_.learnerProgressTracking).map(_ => (_.value)).join(', '))  ))]] 
      communicationFeatures  = () => [[   'Communication'  ,   ...this.products.map(_ => ( (this.undefToValueHashArr(_.communicationFeatures).map(_ => (_.value)).join(', '))  ))]] 
      teachingAndLearningApproaches  = () => [[   'Approaches'  ,   ...this.products.map(_ => ( (this.undefToValueHashArr(_.teachingAndLearningApproaches).map(_ => (_.value)).join(', ')) ))]] 
      planType  = () => [[   'Pricing Model' ,   ...this.products.map(_ => ( (this.undefToValueHashArr(_.planType).map(_ => (_.value)).join(', '))  ))]] 
      inappPurchases  = () => [[   'In-app Purchases'  ,   ...this.products.map(_ => ( (this.undefToValueHashArr(_.inappPurchases).map(_ => (_.value)).join(', '))  ))]] 
      purchaser  = () => [[   'Purchaser' ,   ...this.products.map(_ => ( (this.undefToValueHashArr(_.purchaser).map(_ => (_.value)).join(', '))  ))]] 
      productTraining  = () => [[   'Product Training' ,   ...this.products.map(_ => ( (this.undefToValueHashArr(_.productTraining).map(_ => (_.value)).join(', '))  ))]] 
      productType  = () => [[   'Learning Product Type'  ,   ...this.products.map(_ => ( (this.undefToValueHashArr(_.productType).map(_ => (_.value)).join(', '))  ))]] 
      supportedOperatingSystems  = () => [[   'Supported Operating Systems'  ,   ...this.products.map(_ => ( (this.undefToValueHashArr(_.supportedOperatingSystems).map(_ => (_.value)).join(', '))  ))]] 
      mobileOptimizedStr = () => [[ 'Optimized for Mobile'   ,  ...this.products.map(_ => (_.mobileOptimized==1)?'Yes':((_.mobileOptimized==0)?'No':'N/A'))]]
  
      xlsxTable(){
        return([
          ['Articulate your need, pain point, or problem of practice.'].concat(_.times(this.products.length, _.constant(''))),
        
        ...this.productName(),
        ...this.ultid(),
        ...this.productLink(),
        ...this.indexSiteLink(),
  
        ...this.productDesc(),
        ...this.learningAudience(),
        ...this.educationalLevel(),
        ...this.intendedProductUser(),
        ...this.productCategories(),
        ...this.academicDiscipline(),
        ...this.academicSubjectArea(),
        ...this.academicContentStandards(),
        ...this.contentAttributes(),
  
        ...this.learningInteraction(),
        ...this.learnerProgressTracking(),
        ...this.communicationFeatures(),
        ...this.teachingAndLearningApproaches(),
        ...this.planType(),
        ...this.inappPurchases(),
        ...this.purchaser(),
        ...this.productTraining(),
        ...this.productType(),

        // for new fields 2022Q2
        ...this.hiLevelCsvLineOfValidationsByArea('Interoperability'),
        ...this.activeIntegrationPartnershipsUrl(),
        ...this.compatibleLearningManagementSystems(),
        ...this.sisCompatibility() ,
        ...this.interoperabilityAuthenticationSSO() ,
        ...this.interoperabilityAuthorization() ,
  
        ...this.interoperabilityCost() ,
        ...this.costDescription() ,
        ...this.hiLevelCsvLineOfValidationsByArea('Privacy'),
        ...this.spdcLabelWithUrl() ,
        ...this.privacyPoliciesUrls(),
  
        ...this.privacyStatement() ,
        ...this.learnerData() ,
        ...this.dataUseDescription() ,
        ////
        
        ...this.supportedOperatingSystems(),
        ...this.mobileOptimizedStr(),
  
        ].concat(this.getRubricLines()));
      }
  }
  

async function generateXLSX(workbook, products: any) {

    // Force workbook calculation on load
    workbook.calcProperties.fullCalcOnLoad = true;

    // NOTE: https://docs.google.com/spreadsheets/d/16wUkgzuxD02YOzLX13rzD0H3QjHbLWe6iuOiqsj5sww/edit#gid=0

    // For Rubric dropdown boxes content, see:
    //https://docs.google.com/spreadsheets/d/1LG69sANAmAMMgySZQtBK-lV_DleFh9k-PmVkoBjopMA/edit#gid=0

    
    workbook.views = [
        {
            x: 0, y: 0, width: 10000, height: 20000,
            firstSheet: 0, activeTab: 1, visibility: 'visible'
        }]
        const worksheet = workbook.addWorksheet('My Sheet');

        
        let ws=worksheet
        
        const myBase64Image = await getBase64ImageFromURL( '../images/edtech-index.png')        
        // const myBase64Image = await getBase64ImageFromURL( '../images/no_image_sml.png')
        
        const imageId1 = workbook.addImage({
            base64: myBase64Image,
            extension: 'png',
          });

        // Range coordinates must be in UPPERCASE format   

        worksheet.addImage(imageId1,{
            tl: { col: 0, row: 0.3 },
            ext: { width: 428, height: 50 }
          } );
        ws.getRow(0).height=50

        let currentRow=3   // from 0

        const xlsReader = new xlsLines(products);
        let dataTable = xlsReader.xlsxTable()
        ws.getColumn('A').width = 48

        ws.getRow('1').height=38

        const maxProductColumnToExport = 10

        for (let x= 1 ; x<= maxProductColumnToExport ; x++) {
            ws.getColumn(x+1).width=41
        }

        ws.getColumn('B').width = 41

        const RubricHeaderToShade=xlsReader.RubricHeader()

        let greyTheNthNextRow=
        { '[Enter your own question]':1}

        greyTheNthNextRow[RubricHeaderToShade]=0

        let greyNextRowToCount = -1

        let rubricItemLineNumber=0

        dataTable.forEach( (rowData) => {
            ws.getRow(currentRow).values = rowData
            
            ws.getRow(currentRow).font = {
              name: 'Montserrat',
              size: 10,
              bold: false
            };

            ws.getCell('A'+currentRow).alignment = {wrapText: true}
            ws.getCell('A'+currentRow).font = {
              name: 'Montserrat',
              size: 11,
              bold: true
            };

            ws.getCell('A'+currentRow).alignment = {wrapText: true}


            if ( (greyNextRowToCount??-1) <0){
              greyNextRowToCount = !!(greyTheNthNextRow[ rowData[0]])?greyTheNthNextRow[ rowData[0]]:null
            
            }
            
            if ((greyNextRowToCount==0) || (greyTheNthNextRow[ rowData[0]] == 0)) { 

              coloringRow(currentRow,  'E6E7E8');
            }

            if (greyNextRowToCount>=0 ) {greyNextRowToCount--}


            /// for data validation dropdown
            if (rowData[0] == xlsReader.FirstRubricItem() ) {
              rubricItemLineNumber=1
            }

            const dataValidationOptions = xlsReader.dataValidationOptions(rubricItemLineNumber)

            if (!!dataValidationOptions && products.length > 0) {
              let row=ws.getRow(currentRow)
              let x=1
              for (x=1; x<=products.length; x++) {
                
                const dvJson={
                  type: 'list',
                  allowBlank: false,
                  formulae: dataValidationOptions
                };


                row.getCell(x+1).dataValidation = dvJson
                row.getCell(x+1).alignment = {wrapText: true}
              }
            }

            if (rubricItemLineNumber>0) rubricItemLineNumber++

            currentRow++
        }
        )

        fontARow(4, 'FFFFFF')
        coloringRow(4, '017961')

        coloringRow(3, 'E6E7E8')

        for (let row=0; row<currentRow-1 ; row++) {
          ws.getRow(row).height = 43.5
          ws.getRow(row).alignment = {wrapText:true, vertical: 'top', horizontal: 'left'}
        }

        // Setting row height of specific rows.
        const heightRubricSet1=_.fromPairs(_.map(_.range(44,52), (x)=> [x,55]))
        const customizedRowHeight= Object.assign({42:134,43:72,52:90, 54:72,55:72},heightRubricSet1)
        

        for (const row in customizedRowHeight) {
          ws.getRow(row).height = customizedRowHeight[row]
        }


        return worksheet
        

        function coloringRow(currentRow:number, colorARGB:string) {
          worksheet.getRow(currentRow).eachCell({ includeEmpty: true }, function (cell) {
            worksheet.getCell(cell.address).fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: colorARGB },
            };
          });
        }

        function fontARow(currentRow:number, colorARGB:string) {
          worksheet.getRow(currentRow).eachCell({ includeEmpty: true }, function (cell) {
            worksheet.getCell(cell.address).font = {
              name: 'Montserrat',
              size: 11,
              bold: true,
              color: {argb: colorARGB },
            };
          });
        }
    }